export default "__VITE_ASSET__B0C1EcYM__"